import script from "./InCargCaman.vue?vue&type=script&lang=ts&setup=true"
export * from "./InCargCaman.vue?vue&type=script&lang=ts&setup=true"

import "./InCargCaman.vue?vue&type=style&index=0&id=2cbba8ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbba8ce"]])

export default __exports__